<template>
  <div class="comp-dropdown-filter" ref="advancedFilterRef">
    <template v-if="entity == 101">
      <jw-select v-if="data.poolOption?.length" :trigger-props="{ updateAtScroll: true }" :style="{ width: '140px', borderRadius: '6px' }" v-model="data.poolId" class="drop-down-select" placeholder="请选择线索池" popup-container=".comp-ly-advanced-filter" :allow-clear="false" allow-search :options="data.poolOption" @change="selectPoolId" size="small"></jw-select>
    </template>
    <jw-select v-else :trigger-props="{ updateAtScroll: true }" :style="{ width: '140px', borderRadius: '6px' }" v-model="data.selectValue" class="drop-down-select" popup-container=".comp-ly-advanced-filter" :allow-clear="false" allow-search :popup-visible="data.popupVisible" @click="selectFilter" size="small">
      <!-- 系统常用检索 -->
      <jw-option v-for="item in highList?.filter((v) => v.type === 0)" :key="`${item.name}_${item.scope}_${item.id}`" :value="item.scope" :title="item.name" @click="sceneSelectValue(0, item)">
        <div class="filter-scenario-item">
          <span class="filter-scenario-name">{{ item.name }}</span>
          <div>
            <div class="filter-scenario-icon-sys" @click.stop="" title="设为默认常用检索">
              <icon-star-fill v-if="!item.isDefault" @click="setDefault(item)" class="filter-scenario-icon-star" />
            </div>
            <span title="默认常用检索">
              <icon-star-fill v-if="item.isDefault" class="filter-scenario-icon-star-active" />
            </span>
          </div>
        </div>
      </jw-option>
      <!-- 一定义常用检索 -->
      <jw-option v-for="item in highList?.filter((v) => v.type === 1)" :key="`${item.name}_${item.scope}_${item.id}`" :value="item.id" :title="item.name" @click="sceneSelectValue(1, item)">
        <div class="filter-scenario-item">
          <span class="filter-scenario-name">{{ item.name }}</span>
          <div>
            <div class="filter-scenario-icon" @click.stop="">
              <span title="编辑常用检索">
                <icon-edit @click="addFilterScenario(2, item)" class="filter-scenario-icon-edit" />
              </span>
              <span title="删除常用检索">
                <icon-delete @click="deleteCustom(item)" class="filter-scenario-icon-delete" />
              </span>
              <span title="设为默认常用检索">
                <icon-star-fill v-if="!item.isDefault" @click="setDefault(item)" class="filter-scenario-icon-star" />
              </span>
            </div>
            <span title="默认常用检索">
              <icon-star-fill v-if="item.isDefault" class="filter-scenario-icon-star-active" />
            </span>
          </div>
        </div>
      </jw-option>
      <template #footer>
        <jw-link style="margin: 8px" @click="addFilterScenario(1)">新建常用检索</jw-link>
      </template>
    </jw-select>
    <common-search ref="commonSearchRef" @cb="refresh" :entity="entity"></common-search>
    <div v-if="showOverlay" class="overlay" @click.stop="hideLay"></div>
  </div>
</template>

<script setup>
import { Message, Modal } from '@arco-design/web-vue';
import { onMounted, reactive, ref, watch } from 'vue';
import { publicService } from '@/api/';
import useViewFields from '@/hooks/view-fields';
import { useI18n } from 'vue-i18n';
const emits = defineEmits(['cb']);
const { t } = useI18n();
const props = defineProps({
  entity: {
    type: [String, Number],
    default: ''
  },
  viewId: {
    type: [String, Number],
    default: ''
  },
  highList: {
    type: Array,
    default: () => []
  }
});
const data = reactive({
  selectValue: 0,
  relationObj: {},
  popupVisible: false,
  poolOption: [],
  poolId: null
});

const commonSearchRef = ref();
const showOverlay = ref(false);
const advancedFilterRef = ref(null);
// 点击下拉时显示遮罩层
const selectFilter = () => {
  data.popupVisible = true;
  showOverlay.value = true;
};
// 隐藏遮罩层并关闭下拉（因为新增场景按钮时不会触发下拉框关闭）
const hideLay = async () => {
  showOverlay.value = false;
  data.popupVisible = false;
};
const addFilterScenario = (type, item) => {
  hideLay();
  commonSearchRef.value.openDialog({ type, record: type === 1 ? undefined : item, highList: props.highList });
};
const deleteCustom = (item) => {
  Modal.open({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('删除'),
    content: t('确认要删除常用检索吗？'),
    okText: t('确认'),
    cancelText: t('取消'),
    onOk: () => {
      deleteCondition(item);
    }
  });
};
// 删除自定义场景
const deleteCondition = async (item) => {
  console.log(45, '删除自定义场景');
  try {
    const params = {
      id: item.id,
      entity: props.entity
    };
    const json = await publicService.deleteCondition(params);
    if (!json.error) {
      console.log(95, json.result, data.selectValue, item.id);
      Message.success('删除成功');
      // 删除后把是否是删除的当前项吐出去，以便是否刷新列表（如果删除的不是当前项，不用刷新列表）
      refresh({ type: 'delete', isCurrent: item.id === data.selectValue });
    }
  } catch (e) {
    console.log(e);
  }
};
// 如果删除的是当前选中项，则删除成功后将自动选中默认值并刷新
const updateSceneId = (params) => {
  console.log(120, params);
  // 删除后选中默认值
  data.selectValue = params.id;
};
// 刷新列表
const refresh = (p) => {
  console.log(124, p, data.sceneId);
  // 如果编辑的是当前激活项，则编辑完成后要刷新列表（listPage）并且刷新场景筛选项接口
  if (p?.id === data.selectValue) {
    emits('cb', { type: 1, sceneId: data.selectValue });
  } else if (p?.type === 'delete') {
    // 删除后需要判断是否是当前选中项，如果是则会找当前默认项（如果当前选中项正好是默认项，会从刷新接口中获取新的默认项，再进行赋值+选中）
    emits('cb', p);
  } else {
    emits('cb', { type: 'refresh' });
  }
};
// 设置默认值
const setDefault = async (item) => {
  console.log(112, '设置默认值');
  console.log(45, '自定义场景设置默认值');
  try {
    const params = {
      entity: props.entity,
      defaultId: item.type === 0 ? item.scope : item.id,
      type: item.type
    };
    const json = await publicService.updateStatusCondition(params);
    if (!json.error) {
      console.log(95, json.result);
      Message.success('操作成功');
      refresh();
    }
  } catch (e) {
    console.log(e);
  }
};
// 非线索池的其他对象的场景筛选（需要区分系统场景和自定义场景，根据type==0为系统，==1为自定义）
const sceneSelectValue = (type, item) => {
  console.log('cbaa-dropdown-filter-sceneSelectValue', type, item);
  hideLay();
  // 有type代表要清高级空筛选条件
  data.selectValue = type == 0 ? item.scope : item.id;
  emits('cb', { type: type === 1 ? 1 : undefined, sceneId: data.selectValue, sceneType: item.type });
};
// 根据线索池Id筛选
const selectPoolId = (id) => {
  console.log('cbaa-dropdown-filter-selectPoolId', id);
  emits('cb', { sceneId: id });
};
const { getLeadPoolSelect, filterSearchList } = useViewFields();
onMounted(async () => {});
watch(
  () => advancedFilterRef.value,
  async (v) => {
    if (!v) return;
    // 初始化进入时要根据默认值触发，调用列表页接口
    const sceneItem = props.highList?.find((v) => v.isDefault);
    console.log(149, sceneItem, props.highList);
    // 线索池
    if (props.entity == 101) {
      await getLeadPoolSelect({ entity: props.entity, viewId: props?.viewId || null });
      data.poolOption = filterSearchList.value.leadPoolSelect;
      data.poolId = data.poolOption?.length ? data.poolOption[0]?.value : -1;
      emits('cb', { sceneId: data.poolId, sceneType: undefined });
    } else if (sceneItem) {
      // sceneItem不为空，代表有默认值，需要区分是系统的还是自定义的
      data.selectValue = sceneItem.type == 0 ? sceneItem.scope : sceneItem.id;
      emits('cb', { sceneId: data.selectValue, sceneType: sceneItem.type });
    } else {
      // sceneItem为空，则默认选中第一个（系统场景：全部）（正常情况下肯定会有默认值）
      data.selectValue = 0;
      emits('cb', { sceneId: 0, sceneType: 0 });
    }
  },
  {
    deep: true,
    immediate: data.entity == 101 ? false : true
  }
);
defineExpose({ updateSceneId });
</script>
<style scoped lang="less">
@import './dropdown-filter.less';
</style>
